var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.66,2.86H9.34c-3.58,0-6.49,2.9-6.49,6.49v31.31c0,3.58,2.9,6.49,6.49,6.49h31.31c3.58,0,6.49-2.9,6.49-6.49V9.34c0-3.58-2.9-6.49-6.49-6.49h0Z",
    fill: "#87e64b"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.97,15.54c0-.43-.35-.78-.78-.78h-6.63c-.43,0-.78.35-.78.78v5.25c0,.43.35.78.78.78h1.38c3.33,0,6.04-2.7,6.04-6.04h0Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.19,21.96c-4.09,0-7.41,3.32-7.41,7.41v5.09c0,.43.35.78.78.78h6.63c.43,0,.78-.35.78-.78v-11.71c0-.43-.35-.78-.78-.78h0Z",
    fill: "#191919"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8,14.78h-5.59c-.23,0-.42.32-.42.71v3.49c0,.39-.19.7-.41.7h-2.79c-.23,0-.42-.31-.42-.7v-3.49c0-.39-.19-.71-.41-.71h-5.59c-.23,0-.42.32-.42.71v7.16c0,.31.26.57.57.57h3.87c.27,0,.48.21.48.48v2.67c0,.26-.21.48-.48.48h-3.87c-.31,0-.57.26-.57.57v7.12c0,.38.19.7.42.7h5.59c.23,0,.41-.32.41-.7v-3.59c0-.39.19-.71.42-.71h2.79c.23,0,.41.32.41.71v3.59c0,.38.19.7.42.7h5.59c.23,0,.41-.32.41-.7V15.49c0-.39-.19-.71-.41-.71h0Z",
    fill: "#191919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.e9b4e7acf7d224ff5fd5f5bcd9d89822.svg";
export { ForwardRef as ReactComponent };